import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var PenTool = createReactComponent("PenTool", ["svg", defaultAttributes, [["path", {
  d: "M12 19l7-7 3 3-7 7-3-3z",
  key: "1as30j"
}], ["path", {
  d: "M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z",
  key: "yc5qzr"
}], ["path", {
  d: "M2 2l7.586 7.586",
  key: "106w32"
}], ["circle", {
  cx: "11",
  cy: "11",
  r: "2",
  key: "tihcyj"
}]]]);
export default PenTool;